<template>
  <div class="meetingStep defatult-bg">
    <div class="stepContent">
      <div class="top-header">
        <p style="font-weight: 700;line-height: 30px;font-size: 24px;">高毅资产2026投资报告会</p>
        <p>{{ meetingDate }}</p>
        <p style="margin-top: 5px;">深圳福田香格里拉大酒店</p>
      </div>
      <div
          style="flex:5;display: flex;flex-direction: column;justify-content: center;align-items: center;padding: 0 16px;">
        <img :src="stepImg" alt="" class="meet-step-img" @load="imgComplete(this)">
        <div class="meetingStepBthGroup" v-if="!noBth && imgCompleteShow">
          <van-button type="default" @click="toClientOperateResult"
                      style="width: 100%;background-color: #fff;">填写参会信息
          </van-button>
        </div>
      </div>
    </div>
    <div style="height: 10vh;">
      <footer-message style="color: #fff;"
        title="*请下滑填写参会信息。本次会议为非公开会议，仅限于受邀请的特定人士参加。未经高毅资产书面同意，请勿对外转发或展示本邀请函，感谢您的理解与支持。"
      ></footer-message>
    </div>
  </div>
</template>

<script>
import footerMessage from '@/components/footer-message'
import MeetingStep from '@/assets/2025/meeting-step.png'
import {Date02} from '@/util/constants'
import moments from 'moment'
import {Shares} from '@/util/Share'
import { getMeetingPicture } from '@/service/invitationClientApis'

export default {
  name: "meetingStep",
  components: {footerMessage},
  data() {
    return {
      noBth: "",
      imgCompleteShow: false,
      // meetingDate: moments(new Date(Date02)).format('YYYY.MM.DD')
      meetingDate: '2026.03.27',
    }
  },
  computed: {
    stepImg() {
      return getMeetingPicture()
    }
  },
  methods: {
    toClientOperateResult() {
      this.$router.push({name: "clientOperateResult2024"})
    },
    imgComplete() {
      this.imgCompleteShow = true
    },
    async getInit() {
      // const data = await getMeetingPicture();
      // this.stepImg = data.imgUrl;
      // console.log(data, 'data=========')
    }
  },
  mounted() {
    Shares.shareCode()
    this.noBth = this.$route.query.noBth || "";
    this.getInit();
  }
}
</script>

<style lang="less">
.meetingStep {

  //padding: 0 20px;
  .stepContent {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    height: 90vh;
    overflow: auto;
  }

  .top-header {
    // height: 12vh;
    // line-height: 12vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 50px;

    > p {
      text-align: center;
      margin: 0;
      color: #fff;
      margin-top: 10px;
      font-size: 16px;
      line-height: 18px
    }
  }

  .el-table th,
  .el-table td {
    text-align: center;
    padding: 5px 0;
    color: #333;
    font-weight: 600;
  }

  .el-table--enable-row-hover .el-table__body tr:hover > td {
    background: #fff;
  }

  .el-table .cell {
    padding: 0;
  }
  .meet-step-img{
    width: 100%;
    margin: 28px 0;
    max-width: 320px;
  }
  .meetingStepBthGroup {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    max-width: 368px;

    > button {
      margin-top: 5px;
      width: 100%;
      font-size: 20px;
      font-weight: bold;
      height: 48px;
      // margin-bottom: 10px;
      border: 0;
    }
  }
}
.meetingStep.defatult-bg{
  background-size: 100% 100%;
}
@media (min-width: 768px) {
  /* 针对大于768px的屏幕的样式 */
  .meetingStep{
    .meet-step-img{
      width: 100%;
      margin: 0;
      max-width: 480px;
    }
  }
}

</style>
